import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import "./AccessConfiguration.css";
import into_icon from "../../../../../assets/global_assets/create_data_imgs/into_icon.png";

const emptyPermission = {
  service: "",
  section: "",
  module: "",
  sub_module: [],
  action: "Yes",
};

const CreatePermissionModal = ({
  show,
  handleClose,
  newPermission,
  setNewPermission,
  handleCreatePermission,
  permissionData,
}) => {
  const [isAddingSection, setIsAddingSection] = useState(false);
  const [isAddingModule, setIsAddingModule] = useState(false);

  const availableServices = ["Global", "Registers", "Audit"];
  const permissionList = Array.isArray(permissionData) ? permissionData : [];
  const subModules = Array.isArray(newPermission.sub_module)
    ? newPermission.sub_module
    : [];

  useEffect(() => {
    if (!show) {
      setIsAddingSection(false);
      setIsAddingModule(false);
    }
  }, [show]);

  const closeModal = () => {
    setIsAddingSection(false);
    setIsAddingModule(false);
    handleClose();
  };

  const handleServiceChange = (e) => {
    setNewPermission({
      ...newPermission,
      service: e.target.value,
      section: "",
      module: "",
    });
    setIsAddingSection(false);
    setIsAddingModule(false);
  };

  const handleSectionChange = (e) => {
    const section = e.target.value;
    const filteredModules = [
      ...new Set(
        permissionList
          .filter((item) => item.section === section)
          .map((item) => item.module)
          .filter(Boolean)
      ),
    ];

    setNewPermission({
      ...newPermission,
      section,
      module: filteredModules.length === 1 ? filteredModules[0] : "",
    });
    setIsAddingModule(false);
  };

  const handleModuleChange = (e) => {
    setNewPermission({
      ...newPermission,
      module: e.target.value,
    });
  };

  const availableSections = [
    ...new Set(
      permissionList
        .filter(
          (p) =>
            !newPermission.service ||
            !p.service ||
            p.service === newPermission.service
        )
        .map((p) => p.section)
        .filter(Boolean)
    ),
  ];

  const availableModules = [
    ...new Set(
      permissionList
        .filter((p) => p.section === newPermission.section)
        .map((p) => p.module)
        .filter(Boolean)
    ),
  ];

  const onSubmit = (e) => {
    e.preventDefault();
    handleCreatePermission();
  };

  const updateSubmodule = (index, field, value) => {
    const updated = subModules.map((sub, i) =>
      i === index ? { ...sub, [field]: value } : sub
    );
    setNewPermission({ ...newPermission, sub_module: updated });
  };

  return (
    <Modal
      show={show}
      onHide={closeModal}
      centered
      dialogClassName="custom-modal-dialog"
      backdrop="static"
      keyboard={false}
      style={{ zIndex: "9999" }}
      className="bg-transparent access-permission-modal"
    >
      <div
        className="row d-flex justify-content-center align-items-center w-100 bg-transparent"
        style={{ marginTop: "10px" }}
      >
        <div
          className="bg-white text-white"
          style={{
            minWidth: "580px",
            maxWidth: "640px",
            padding: "5px",
            borderRadius: "10px",
            overflow: "hidden",
            marginLeft: "20px",
          }}
        >
          <div className="row accessConfigurationTableMainContainer rounded">
            <div className="col-md-12">
              <div className="row">
                <div className="close-btn-div">
                  <button
                    type="button"
                    className="float-end bg-light"
                    onClick={closeModal}
                    aria-label="Close"
                  >
                    <img src={into_icon} alt="" />
                  </button>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="createFormTitle text-dark">
                    <form onSubmit={onSubmit}>
                      <div className="title">
                        <h5>Create Permission</h5>
                        <p>
                          Create a new permission by selecting a service, section,
                          and module. Use this to control access in the system.
                        </p>
                      </div>

                      <div className="mb-2">
                        <label>
                          Service <span className="text-danger">*</span>
                        </label>
                        <select
                          className="form-control"
                          value={newPermission.service || ""}
                          onChange={handleServiceChange}
                        >
                          <option value="">-- Select Service --</option>
                          {availableServices.map((service) => (
                            <option key={service} value={service}>
                              {service}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="mb-2">
                        <label>
                          Section <span className="text-danger">*</span>
                        </label>
                        {!isAddingSection ? (
                          <div className="d-flex align-items-center gap-2">
                            <select
                              className="form-control"
                              value={newPermission.section || ""}
                              onChange={handleSectionChange}
                            >
                              <option value="">-- Select Section --</option>
                              {availableSections.map((section) => (
                                <option key={section} value={section}>
                                  {section}
                                </option>
                              ))}
                            </select>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm access-inline-btn"
                              onClick={() => {
                                setIsAddingSection(true);
                                setIsAddingModule(true);
                                setNewPermission({
                                  ...newPermission,
                                  section: "",
                                  module: "",
                                });
                              }}
                            >
                              Add New
                            </button>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center gap-2">
                            <input
                              type="text"
                              className="form-control"
                              value={newPermission.section || ""}
                              onChange={(e) =>
                                setNewPermission({
                                  ...newPermission,
                                  section: e.target.value,
                                })
                              }
                              placeholder="Enter new section"
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm access-inline-btn"
                              onClick={() => {
                                setIsAddingSection(false);
                                setIsAddingModule(false);
                                setNewPermission({
                                  ...newPermission,
                                  section: "",
                                  module: "",
                                });
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="mb-2">
                        <label>
                          Module <span className="text-danger">*</span>
                        </label>
                        {!isAddingModule ? (
                          <div className="d-flex align-items-center gap-2">
                            <select
                              className="form-control"
                              value={newPermission.module || ""}
                              onChange={handleModuleChange}
                            >
                              <option value="">-- Select Module --</option>
                              {availableModules.map((module) => (
                                <option key={module} value={module}>
                                  {module}
                                </option>
                              ))}
                            </select>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm access-inline-btn"
                              onClick={() => {
                                setIsAddingModule(true);
                                setNewPermission({
                                  ...newPermission,
                                  module: "",
                                });
                              }}
                            >
                              Add New
                            </button>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center gap-2">
                            <input
                              type="text"
                              className="form-control"
                              value={newPermission.module || ""}
                              onChange={(e) =>
                                setNewPermission({
                                  ...newPermission,
                                  module: e.target.value,
                                })
                              }
                              placeholder="Enter new module"
                            />
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm access-inline-btn"
                              onClick={() => {
                                setIsAddingModule(false);
                                setNewPermission({
                                  ...newPermission,
                                  module: "",
                                });
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        )}
                      </div>

                      <div className="form-check access-allow-action">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="perm-action"
                          checked={newPermission.action === "Yes"}
                          onChange={() =>
                            setNewPermission({
                              ...newPermission,
                              action:
                                newPermission.action === "Yes" ? "No" : "Yes",
                            })
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor="perm-action"
                        >
                          Allow Module Action
                        </label>
                      </div>

                      {subModules.map((sub, index) => (
                        <div
                          key={index}
                          className="row align-items-end mb-2 access-submodule-row"
                        >
                          <div className="col-md-6">
                            <label>Sub Module</label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Submodule name"
                              value={sub.name || ""}
                              onChange={(e) =>
                                updateSubmodule(index, "name", e.target.value)
                              }
                            />
                          </div>
                          <div className="col-md-3">
                            <label>Action</label>
                            <select
                              className="form-select"
                              value={sub.action || "Yes"}
                              onChange={(e) =>
                                updateSubmodule(index, "action", e.target.value)
                              }
                            >
                              <option value="Yes">Yes</option>
                              <option value="No">No</option>
                            </select>
                          </div>
                          <div className="col-md-3">
                            <button
                              type="button"
                              className="btn btn-outline-danger btn-sm w-100"
                              onClick={() =>
                                setNewPermission({
                                  ...newPermission,
                                  sub_module: subModules.filter(
                                    (_, i) => i !== index
                                  ),
                                })
                              }
                            >
                              Remove
                            </button>
                          </div>
                        </div>
                      ))}

                      <button
                        type="button"
                        className="btn btn-outline-secondary btn-sm mt-1 mb-2"
                        onClick={() =>
                          setNewPermission({
                            ...newPermission,
                            sub_module: [
                              ...subModules,
                              { name: "", action: "Yes" },
                            ],
                          })
                        }
                      >
                        + Add Submodule
                      </button>

                      <div className="col-md-12 mt-1 mb-2">
                        <button className="w-100 btn formSubmitBtn" type="submit">
                          Submit
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default CreatePermissionModal;
export { emptyPermission };
